import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import PayButton from '../paybutton'
import Voucherbutton from '../voucherbutton'
import { getStage } from '../../actions/stages'
import { getInvite } from '../../actions/invites'
import op from '../../util/objectPath'
import './styles.css'
import delay from 'delay'
import { getUser } from '../../actions/users'

const PaymentOptions = () => {
  const dispatch = useDispatch()
  const [lifecycle, setLifecycle] = useState('init')
  const [buttonDisplay, setButtonDisplay] = useState('none')
  const [stageId, setStageId] = useState(null)
  const [inviteId, setInviteId] = useState(null)

  const stageInfo = useSelector(state => op(state, `stages.list[${stageId}]`))
  const inviteInfo = useSelector(state => op(state, `invites.list[${inviteId}]`))

  useEffect(() => {
    const localStageId = window.localStorage['registerStageId']
    const localInviteId = localStageId != null ? null : window.localStorage['inviteId'] // not both at the same time
    setStageId(localStageId)
    setInviteId(localInviteId)
  }, [])

  useEffect(() => {
    if (stageId || inviteId) {
      setButtonDisplay('all')
      setLifecycle('ready')
    } else {
      setButtonDisplay('none')
    }
  }, [stageId, inviteId])

  useEffect(() => {
    if (stageId != null) {
      getStage(stageId)(dispatch)
    }
  }, [stageId])

  useEffect(() => {
    if (inviteId != null) {
      getInvite(inviteId)(dispatch)
    }
  }, [inviteId])

  const clearLocalStorage = () => {
    if (stageId != null) {
      window.localStorage.removeItem('registerStageId')
    } else if (inviteId != null) {
      window.localStorage.removeItem('inviteId')
    }
  }

  const onEnded = async (success) => {
    clearLocalStorage()
    setLifecycle('processing')
    // refresh data
    await delay(3000)
    if (stageId != null) {
      await getStage(stageId)(dispatch)
    }
    if (inviteId != null) {
      await getInvite(inviteId)(dispatch)
    }
    setButtonDisplay('none')
    setLifecycle('ended')
  }

  const onCancelClick = () => {
    clearLocalStorage()
    setButtonDisplay('none')
    setLifecycle('canceled')
  }

  let alertText = null
  let showActions = false

  if (lifecycle === 'ready') {
    if (stageId != null && stageInfo != null) {
      if (stageInfo.officialTeam == null) {
        showActions = true
        alertText = <>It looks like you are about to register for <strong>Stage {stageId}</strong>!
                      To fully register and crowdfund the book you will co-create we kindly ask you to pay 249 euro. 
                      You will receive the book with contribution of all participants at the end of the journey.</>
      } else {
        showActions = false
        alertText = <>It looks like you are about to register for <strong>Stage {stageId}</strong>!
                      This stage is already taken by another team, so you can no longer claim it.
                      <div className="mt-3"><button className="btn btn-primary" onClick={onCancelClick}>Ok</button></div></>
      }
    } else if (inviteId != null && inviteInfo != null) {
      if (inviteInfo.deleted === false) {
        showActions = true
        alertText = <>Someone has invited you to join a team. To fully register and crowdfund the book you will co-create we kindly ask you to pay 249 euro. 
                      You will receive the book with contribution of all participants at the end of the journey.</>
      } else {
        showActions = false
        alertText = <>Someone has invited you to join a team, but the invite code is already claimed. It can no longer be used. 
                      If you still like to be invited you should request a new invite code. Please contact someone from that team to provide you a new link.
                    <div className="mt-3"><button className="btn btn-primary" onClick={onCancelClick}>Ok</button></div></>
      }
    }
  } else if (lifecycle === 'processing') {
    showActions = false
    alertText = 'Checking...'
  } else if (lifecycle === 'ended') {
    showActions = false
    if (stageInfo != null && stageInfo.officialTeam != null) {
      alertText = <>You have claimed stage {stageInfo.stageId}! This also means you have created a new team to run this stage. 
                    Click <Link to={'team/' + stageInfo.officialTeam.teamId}>here</Link> to edit your team detail.</>
    } else if (inviteInfo != null) {
      alertText = <>Your invite has been processed. Check out the team your have joined by clicking <Link to={'team/' + inviteInfo.teamId}>here</Link>.</>
    }
  }

  return (
    <div className='payment-options'>
      { (alertText != null) && (
        <div className='alert alert-primary' role='alert'>
          {alertText}
        </div> )
      }
      { (showActions === true) && (
        <div className={buttonDisplay === 'all' ? 'buttons' : ''}>
        { (buttonDisplay === 'all' || buttonDisplay === 'card') && <PayButton stageId={stageId} inviteId={inviteId} onStarted={() => setButtonDisplay('card')} onEnded={onEnded} onCancel={() => setButtonDisplay('all')} /> }
        { (buttonDisplay === 'all' || buttonDisplay === 'voucher') && <Voucherbutton stageId={stageId} inviteId={inviteId} onStarted={() => setButtonDisplay('voucher')} onEnded={onEnded} onCancel={() => setButtonDisplay('all')} /> }
        { (buttonDisplay === 'all' || buttonDisplay === 'cancel') &&  <button className="btn btn-primary" onClick={onCancelClick}>Cancel</button> }
        </div> )
      }
      </div> )
}

export default PaymentOptions